/** @format */
import { getTahunActive } from "../../services/v2/referenceservice/tahun";
import { StoreActions } from "../actionsName";

export const setPeriodeTahunActive =
  () =>
  (dispatch: any): void => {
    getTahunActive()
      .then((data) => {
        dispatch({ type: StoreActions.SET_TAHUN_PERIODE_ACTIVE, data: data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

/** Set Store */
export const setStore = (data) => ({
  type: StoreActions.SET_STORE,
  data: data,
});

/** Delete Store */
export const setClearStore = () => ({
  type: StoreActions.CLEAR_STORE,
});
